import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { appGetLocale, appPathPrefix, isMobileAspectRatio } from '../helpers/appHelper';
import { getRecruitNews } from '../apis';
import { yamazaki_brown } from '../styles/color';

const Recruit = () => {
    const appLanguage = appGetLocale();
    const isEng = appLanguage === 'en';
    const [news, setNews] = useState([]);
    const prefix = appPathPrefix();
    const isMobile = isMobileAspectRatio();

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const news_result = await getRecruitNews();
        if (!news_result.fail) {
            setNews(news_result);
        }
    };

    const NavBar = () => (
        <div className="recruit-nav">
            <a href={prefix + "/"} style={{ color: yamazaki_brown, textDecoration: 'none' }}>
                <span>
                    <FormattedMessage id={'menus.home'} />
                </span>
            </a>
            <span> {">"} </span>
            <span style={{ fontWeight: 'bold' }}>
                <FormattedMessage id={'menus.recruit'} />
            </span>
        </div>
    );

    const RecruitBanner = () => {
        const sliderRef = useRef(null);
        const [currentIndex, setCurrentIndex] = useState(0);
        const loop_timer = 5000;

        useEffect(() => {
            const handleScroll = () => {
                if (sliderRef.current) {
                    const scrollLeft = sliderRef.current.scrollLeft;
                    const scrollAmount = getScrollAmount();
                    const index = Math.round(scrollLeft / scrollAmount);
                    setCurrentIndex(index);
                }
            };

            if (sliderRef.current) sliderRef.current.addEventListener('scroll', handleScroll);
            return () => {
                if (sliderRef.current) sliderRef.current.removeEventListener('scroll', handleScroll);
            };
        }, []);

        useEffect(() => {
            const interval = setInterval(() => {
                scrollNext();
            }, loop_timer);
            return () => clearInterval(interval);
        }, [currentIndex]);

        const getScrollAmount = () => {
            if (sliderRef.current) {
                const firstImage = sliderRef.current.querySelector('.recruit-banner-image');
                if (firstImage) {
                    return firstImage.clientWidth;
                }
            }
            return 1277;
        };

        const scrollNext = () => {
            const scrollAmount = getScrollAmount();
            if (sliderRef.current) {
                if (currentIndex === news.length - 1) {
                    sliderRef.current.scrollTo({ left: 0, behavior: 'smooth' });
                } else {
                    sliderRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
                }
            }
        };

        const scrollPrev = () => {
            const scrollAmount = getScrollAmount();
            if (sliderRef.current) {
                if (currentIndex === 0) {
                    sliderRef.current.scrollTo({ left: sliderRef.current.scrollWidth, behavior: 'smooth' });
                } else {
                    sliderRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
                }
            }
        };

        const scrollTo = (index) => {
            const scrollAmount = getScrollAmount();
            if (sliderRef.current) {
                sliderRef.current.scrollTo({ left: index * scrollAmount, behavior: 'smooth' });
            }
        };

        return (
            <div className="recruit-banner">
                <div className="recruit-banner-images-container" ref={sliderRef}>
                    {news.map((image, index) => (
                        <img
                            key={index}
                            className="recruit-banner-image"
                            src={image?.web_thumbnail_url}
                        />
                    ))}
                </div>
            </div>
        )
    };

    const RecruitStaff = () => {
        return (
            <div className="recruit-staff-outside">
                <div className="recruit-staff-container">
                    <div className="recruit-staff">
                        <div className="recruit-staff-shop">
                            <span className="recruit-staff-shop-title">
                                <FormattedMessage id={'recruit.staffShop'} />
                            </span>
                            <a href={prefix + '/careers/baker'} style={{ textDecoration: 'none' }}>
                                <div className="recruit-staff-shop-baker">
                                    <img src="./images/baker.png" />
                                    <FormattedMessage id={'recruit.staffBaker'} />
                                </div>
                            </a>
                            <a href={prefix + '/careers/sales'} style={{ textDecoration: 'none' }}>
                                <div className="recruit-staff-shop-sales">
                                    <img src="./images/sales.png" />
                                    <FormattedMessage id={'recruit.staffSales'} />
                                </div>
                            </a>
                        </div>
                        <div className="recruit-staff-non-shop">
                            <span className="recruit-staff-non-shop-title">
                                <FormattedMessage id={'recruit.staffNonShop'} />
                            </span>
                            <a href={prefix + '/careers/logistics'} style={{ textDecoration: 'none', width: '33%', display: 'flex', justifyContent: 'center' }}>
                                <div className="recruit-staff-non-shop-logistics">
                                    <img src="./images/logistics.png" />
                                    <FormattedMessage id={'recruit.staffLogistics'} />
                                </div>
                            </a>
                            <a href={prefix + '/careers/factory'} style={{ textDecoration: 'none', width: '33%', display: 'flex', justifyContent: 'center' }}>
                                <div className="recruit-staff-non-shop-factory">
                                    <img src="./images/factory.png" />
                                    <FormattedMessage id={'recruit.staffFactory'} />
                                </div>
                            </a>
                            <a href={prefix + '/careers/office'} style={{ textDecoration: 'none', width: '33%', display: 'flex', justifyContent: 'center' }}>
                                <div className="recruit-staff-non-shop-office">
                                    <img src="./images/office.png" />
                                    <FormattedMessage id={'recruit.staffOffice'} />
                                    <br/>
                                    <FormattedMessage id={'recruit.staffOffice2'} />
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        )
    };
    const MobileRecruitStaff = () => {
        return (
            <div className="recruit-staff-container">
                <div className="recruit-staff">
                    <span className="recruit-staff-shop-title">
                        <img src="./images/mobile-recurit-shop-icon.png" />
                        <FormattedMessage id={'recruit.staffShop'} />
                    </span>
                    <div className="recruit-staff-shop">
                        <a href={prefix + '/careers/baker'} style={{ textDecoration: 'none' }}>
                            <div className="recruit-staff-shop-baker">
                                <img src="./images/baker.png" />
                                <FormattedMessage id={'recruit.staffBakerMobile'} />
                            </div>
                        </a>
                        <a href={prefix + '/careers/sales'} style={{ textDecoration: 'none' }}>
                            <div className="recruit-staff-shop-sales">
                                <img src="./images/sales.png" />
                                <FormattedMessage id={'recruit.staffSalesMobile'} />
                            </div>
                        </a>
                    </div>
                    <span className="recruit-staff-non-shop-title">
                        <img src="./images/mobile-recurit-factory-icon.png" />
                        <FormattedMessage id={'recruit.staffNonShopFactory'} />
                        {" / "}
                        <img src="./images/mobile-recurit-office-icon.png" />
                        <FormattedMessage id={'recruit.staffNonShopOffice'} />
                    </span>
                    <div className="recruit-staff-non-shop">
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: "space-around", width: "100%" }}>
                            <a href={prefix + '/careers/factory'} style={{ textDecoration: 'none', width: '100%' }}>
                                <div className="recruit-staff-non-shop-factory" style={{ justifyContent: 'center' }}>
                                    <img src="./images/factory.png" />
                                    <FormattedMessage id={'recruit.staffFactory'} />
                                </div>
                            </a>
                            <a href={prefix + '/careers/office'} style={{ textDecoration: 'none', width: '100%' }}>
                                <div className="recruit-staff-non-shop-office" style={{ justifyContent: 'center' }}>
                                    <img src="./images/office.png" />
                                    <FormattedMessage id={'recruit.staffOffice'} />
                                </div>
                            </a>
                        </div>
                        <a href={prefix + '/careers/logistics'} style={{ textDecoration: 'none' }}>
                            <div className="recruit-staff-non-shop-logistics">
                                <img src="./images/logistics.png" />
                                <FormattedMessage id={'recruit.staffLogistics'} />
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        )
    };

    return (
        <div className='recruit'>
            <div className="recruit-background">
                <img src='./images/recruit_background.png' />
                <span className="recruit-title" style={{ letterSpacing: isEng?'0':'1.5vw' }}>
                    <FormattedMessage id={'recruit.title'} />
                </span>
            </div>
            {isMobile && <NavBar />}
            <div className='recruit-job-nature'>
                <FormattedMessage id={'recruit.jobNature'} />
            </div>
            <RecruitBanner />
            {isMobile?<MobileRecruitStaff />:<RecruitStaff />}
        </div>
    )
};

export default Recruit;